import {getMountedLanguages} from './mountedLanguages';
import reduce from 'lodash/reduce';
import compose from 'lodash/fp/compose';
import mapFp from 'lodash/fp/map';
import filterFp from 'lodash/fp/filter';
import getFp from 'lodash/fp/get';
import replaceFp from 'lodash/fp/replace';
import join from 'lodash/join';
import uniq from 'lodash/uniq';
import values from 'lodash/values';
import compact from 'lodash/compact';
import head from 'lodash/head';
import zipObject from 'lodash/zipObject';
import isPlainObject from 'lodash/isPlainObject';
import pick from 'lodash/pick';
import keys from 'lodash/keys';
import isArray from 'lodash/isArray';
import map from 'lodash/map';

import {isSubArray} from '@/utils/localeUtils';

export const getValidValue = compose(
  head,
  compact,
  values,
);

export const availableLanguages = getMountedLanguages();

export const emptyValue = zipObject(availableLanguages);

export const parceValueLanguage = (values = {}, newValue, lang) => {
  const defaultValue = getValidValue(values);

  return reduce({
    ...emptyValue,
    ...values,
    [lang]: newValue
  }, (acc, value, key) => {
    if (value) {
      value = defaultValue;
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});
};

export const getSetOfTranslatedFields = compose(
  v => new Set(v),
  uniq,
  mapFp(replaceFp(new RegExp(`.(${join(availableLanguages, '|')})`, 'g'), '')),
  mapFp(getFp('key')),
  filterFp(getFp('i18n')),
);

export const createTranslatedPayload = (fields, disabled) => {
  if (disabled) {
    return payload => payload;
  }

  const fieldsToTranslate = getSetOfTranslatedFields(fields);

  const autoCompleteEmptyValues = (payload) => reduce(payload, (acc, value = {}, key) => {
    if (fieldsToTranslate.has(key)) {
      const predominantValue = isPlainObject(value) ? getValidValue(value) : value;
      value = reduce({
        ...emptyValue,
        ...(isPlainObject(value) ? value : {}),
      }, (acc, val, lang) => !val ? {...acc, [lang]: predominantValue} : {...acc, [lang]: val}, {});

      value = pick(value, availableLanguages);
    }

    return {
      ...acc,
      [key]: value
    };
  }, {});

  const clearPayload = (payload) => reduce(payload, (acc, value = {}, key) => {
    if (fieldsToTranslate.has(key)) {
      value = pick(value, availableLanguages);
    }

    return {
      ...acc,
      [key]: value
    };
  }, {});

  return (payload, clearOnly) => {
    if (clearOnly) {
      return clearPayload(payload);
    }

    return autoCompleteEmptyValues(payload);
  };
};

export function implicitTranslatePayload(rawData) {
  if (isArray(rawData)) {
    return map(rawData, implicitTranslatePayload);
  } else if (isPlainObject(rawData)) {
    if (isSubArray(keys(rawData), availableLanguages)) {
      const defaultValue = getValidValue(rawData);
      return reduce(availableLanguages, (acc, lang) => {
        const value = rawData[lang] || defaultValue;
        return {
          ...acc,
          [lang]: value
        };
      }, {});
    } else {
      return reduce(rawData, (acc, value, key) => {
        const _value = implicitTranslatePayload(value);
        return {
          ...acc,
          [key]: _value
        };
      }, {});
    }
  } else {
    return rawData;
  }
}


export const stringifyTranslatePayload = (rawData) => {
  const data = implicitTranslatePayload(rawData);
  return JSON.stringify(data);
};
